module.exports = __webpack_public_path__ + "static/media/girl-9.a1360784.svg";